import { combineReducers, configureStore } from '@reduxjs/toolkit'
import FilterReducer from './reducer/filter.reducer'
import UserReducer from './reducer/user.reducer'
import DisableScreensReducer from './reducer/disablescreens.reducer';
import AllocationComplianceReducer  from './reducer/allocationCompliance.reducer';

const rootReducer = combineReducers({
    filters: FilterReducer,
    user: UserReducer,
    disableScreens: DisableScreensReducer,
    allocationCompliance: AllocationComplianceReducer
})

const store = configureStore({
    reducer: rootReducer,
})

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch